import React from 'react';
import useGetTagsInUse from '../../api/useGetTagsInUse';
import { useQuery } from 'react-query';
import { Link } from 'react-router-dom';
import { Card, CardHeader, CardBody, Button } from 'reactstrap';
import DisplayQueryError from './DisplayQueryError';
import LoadingSpinner from './LoadingSpinner';

const TopicCloud: React.FC = () => {
    const getTagsInUse = useGetTagsInUse();
    const {
        data: tags,
        isLoading,
        error,
        refetch
    } = useQuery('tagsInUse', getTagsInUse);

    if (error) {
        return <DisplayQueryError error={error} refetch={refetch} />;
    }

    if (isLoading || !tags) {
        return <LoadingSpinner />;
    }

    if (!tags.length) {
        return null;
    }

    return (
        <Card className='mt-4'>
            <CardHeader>
                <div className='d-flex align-items-center'>
                    <svg
                        xmlns='http://www.w3.org/2000/svg'
                        viewBox='0 0 512 512'
                        className='me-2'
                        width='24'
                        height='24'
                    >
                        {/* Font Awesome Pro 6.2.0 by fontawesome */}
                        <defs>
                            <linearGradient
                                id='linear-gradient'
                                x1='0.077'
                                y1='1.363'
                                x2='1.183'
                                y2='0.148'
                                gradientUnits='objectBoundingBox'
                            >
                                <stop offset='0' stopColor='var(--primary)' />
                                <stop
                                    offset='1'
                                    stopColor='var(--primary-light)'
                                />
                            </linearGradient>
                        </defs>
                        <path
                            fill='url(#linear-gradient)'
                            d='M345 39.1L472.8 168.4c52.4 53 52.4 138.2 0 191.2L360.8 472.9c-9.3 9.4-24.5 9.5-33.9
              .2s-9.5-24.5-.2-33.9L438.6 325.9c33.9-34.3 33.9-89.4 0-123.7L310.9 72.9c-9.3-9.4-9.2-24.6
              .2-33.9s24.6-9.2 33.9 .2zM0 229.5V80C0 53.5 21.5 32 48 32H197.5c17 0 33.3 6.7 45.3 18.7l168
              168c25 25 25 65.5 0 90.5L277.3 442.7c-25 25-65.5 25-90.5 0l-168-168C6.7 262.7 0 246.5 0
              229.5zM144 144c0-17.7-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32z'
                        />
                    </svg>
                    <h3 className='mb-0'>All topics</h3>
                </div>
            </CardHeader>
            <CardBody className='mt-3'>
                <div className='d-flex flex-wrap gap-2'>
                    {tags.map((tag) => (
                        <Button
                            key={tag.id}
                            outline
                            color='primary'
                            className='rounded-pill'
                            tag={Link}
                            to={`/topic/${encodeURIComponent(tag.text)}`}
                        >
                            {tag.text}
                        </Button>
                    ))}
                </div>
            </CardBody>
        </Card>
    );
};

export default TopicCloud;
